<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  @if (editMode) {
    <span>Rediger komponent</span>
  }
  @if (!editMode) {
    <span>Opret komponent</span>
  }
</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-label class="form-headline">Komponenttype</mat-label>
      <mat-radio-group formControlName="komponentTypeId">
        @for (komponenttype of komponentTyper; track komponenttype) {
          <mat-radio-button [value]="komponenttype.id">
            {{ komponenttype.text }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Model</mat-label>
        <input formControlName="model" matInput />
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Serienummer</mat-label>
        <input formControlName="serienummer" matInput />
      </mat-form-field>
      @for (komponent of matchingKomponenter; track komponent) {
        <div class="flex orange cursor-help">
          <mat-icon svgIcon="obs-solid"></mat-icon>
          <span>
            Dette serienummer er anvendt før på komponent {{ komponent.model }}. Check venligst at du ikke ved en fejl har dobbeltoprettet?
          </span>
        </div>
      }
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Installations dato</mat-label>
        <input #installationInput matInput [matDatepicker]="installationDatePicker" formControlName="installationDate" />
        <mat-datepicker-toggle matPrefix [for]="installationDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #installationDatePicker></mat-datepicker>
      </mat-form-field>
      @if (isComponentOlder()) {
        <mat-error>
          Denne installationsdato for komponenten er ældre end anlægget. Et anlæg kan ikke være nyere end dets bestanddele. Hvis du går videre
          sættes en ny installationsdato for anlægget.
        </mat-error>
      }
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Garantiperiode</mat-label>
        <input type="number" formControlName="garantiPeriode" matInput step="1" />
        <span matSuffix>måneder</span>
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  @if (!editMode) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Tilføj</button>
  }
  @if (editMode) {
    <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
  }
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
